export default __webpack_public_path__ + "static/media/ich.d91cf81c.gif";